const schedule = {
    Monday: [
      { name: "BJJ Gi", start: 7, end: 8.5 },
      { name: "Pro Training", start: 12, end: 13 },
      { name: "Kids (4-7)", start: 16, end: 16.5 },
      { name: "Kids (7-13)", start: 17, end: 18 },
      { name: "Teens", start: 18, end: 19 },
      { name: "BJJ Gi", start: 19, end: 20 }
    ],
    Tuesday: [
      { name: "BJJ Gi", start: 7, end: 8.5 },
      { name: "Pro Training", start: 12, end: 13 },
      { name: "Kids (4-7)", start: 16, end: 16.5 },
      { name: "Kids (7-13)", start: 17, end: 18 },
      { name: "Teens", start: 18, end: 19 },
      { name: "BJJ Gi", start: 19, end: 20 }
    ],
    Wednesday: [
      { name: "BJJ Gi", start: 7, end: 8.5 },
      { name: "Pro Training", start: 12, end: 13 },
      { name: "Kids (4-7)", start: 16, end: 16.5 },
      { name: "Kids (7-13)", start: 17, end: 18 },
      { name: "Teens", start: 18, end: 19 },
      { name: "BJJ Gi", start: 19, end: 20 }
    ],
    Thursday: [
      { name: "BJJ Gi", start: 7, end: 8.5 },
      { name: "Pro Training", start: 12, end: 13 },
      { name: "Kids (4-7)", start: 16, end: 16.5 },
      { name: "Kids (7-13)", start: 17, end: 18 },
      { name: "Teens", start: 18, end: 19 },
      { name: "BJJ Gi", start: 19, end: 20 }
    ],
    Friday: [
      { name: "Open Mat", start: 18, end: 19 },
      
    ],
    Saturday: [
      { name: "Open Mat", start: 12, end: 13 }
    ]
  };
export default schedule  